import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { 
  Home, 
  UserCheck, 
  Wallet, 
  Truck,
  BarChart3
} from 'lucide-react';

const BottomNavigation = ({ 
  isOnline = true, 
  onAttendanceClick,
  onReportsClick,
  activeTab = 'dashboard',
  showReports = false
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleReportsClick = () => {
    if (onReportsClick) {
      onReportsClick();
    } else {
      // Default behavior: navigate to dashboard with reports tab
      navigate('/?tab=reports');
    }
  };

  const handleHomeClick = () => {
    navigate('/?tab=dashboard');
  };

  const navItems = [
    {
      id: 'dashboard',
      label: 'Home',
      icon: Home,
      onClick: handleHomeClick,
      isActive: location.pathname === '/' && activeTab === 'dashboard'
    },
    {
      id: 'order',
      label: 'Order',
      icon: Truck,
      onClick: () => navigate('/raw-material-order'),
      isActive: location.pathname === '/raw-material-order'
    },
    {
      id: 'reports',
      label: 'Reports',
      icon: BarChart3,
      onClick: handleReportsClick,
      isActive: showReports || activeTab === 'reports'
    },
    {
      id: 'attendance',
      label: 'Attend',
      icon: UserCheck,
      onClick: onAttendanceClick,
      isActive: false
    },
    {
      id: 'ledger',
      label: 'Ledger',
      icon: Wallet,
      onClick: () => navigate('/ledger-management'),
      isActive: location.pathname === '/ledger-management'
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-surface border-t border-border shadow-lg z-50 safe-area-bottom">
      <div className="max-w-7xl mx-auto grid grid-cols-5 gap-0.5 py-1 px-1">
        {navItems.map((item) => (
          <Button
            key={item.id}
            data-testid={`${item.id}-nav-btn`}
            variant={item.isActive ? 'default' : 'ghost'}
            className={`
              flex-col h-14 sm:h-12 px-1 sm:px-3 font-medium rounded-lg
              ${item.isActive ? 'bg-primary text-white hover:bg-primary/90' : 'text-muted-foreground hover:text-foreground hover:bg-muted'}
            `}
            onClick={item.onClick}
          >
            <item.icon className="h-5 w-5 mb-0.5" />
            <span className="text-[10px] sm:text-xs uppercase tracking-wide leading-tight">
              {item.label}
            </span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;
